// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetUserLandingPagePreferenceResponseDto } from '../models';
// @ts-ignore
import type { UpdateUserLandingPagePreferenceRequestDto } from '../models';
/**
 * UserLandingPagePreferenceRestApi - axios parameter creator
 */
export const UserLandingPagePreferenceRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the user\'s preferred landing page. Returns MY_PROFILE if not set.
         * @summary Get user\'s landing page preference
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLandingPagePreference: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserLandingPagePreference', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}/landing-page`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the user\'s preferred landing page for the application
         * @summary Update user\'s landing page preference
         * @param {string} userId 
         * @param {UpdateUserLandingPagePreferenceRequestDto} updateUserLandingPagePreferenceRequestDto Landing page preference to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLandingPagePreference: async (userId: string, updateUserLandingPagePreferenceRequestDto: UpdateUserLandingPagePreferenceRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserLandingPagePreference', 'userId', userId)
            // verify required parameter 'updateUserLandingPagePreferenceRequestDto' is not null or undefined
            assertParamExists('updateUserLandingPagePreference', 'updateUserLandingPagePreferenceRequestDto', updateUserLandingPagePreferenceRequestDto)
            const localVarPath = `/api/v1/users/{userId}/landing-page`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserLandingPagePreferenceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLandingPagePreferenceRestApi - functional programming interface
 */
export const UserLandingPagePreferenceRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserLandingPagePreferenceRestApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the user\'s preferred landing page. Returns MY_PROFILE if not set.
         * @summary Get user\'s landing page preference
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLandingPagePreference(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserLandingPagePreferenceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLandingPagePreference(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLandingPagePreferenceRestApi.getUserLandingPagePreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets the user\'s preferred landing page for the application
         * @summary Update user\'s landing page preference
         * @param {string} userId 
         * @param {UpdateUserLandingPagePreferenceRequestDto} updateUserLandingPagePreferenceRequestDto Landing page preference to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserLandingPagePreference(userId: string, updateUserLandingPagePreferenceRequestDto: UpdateUserLandingPagePreferenceRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserLandingPagePreference(userId, updateUserLandingPagePreferenceRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLandingPagePreferenceRestApi.updateUserLandingPagePreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserLandingPagePreferenceRestApi - factory interface
 */
export const UserLandingPagePreferenceRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserLandingPagePreferenceRestApiFp(configuration)
    return {
        /**
         * Returns the user\'s preferred landing page. Returns MY_PROFILE if not set.
         * @summary Get user\'s landing page preference
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLandingPagePreference(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserLandingPagePreferenceResponseDto> {
            return localVarFp.getUserLandingPagePreference(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the user\'s preferred landing page for the application
         * @summary Update user\'s landing page preference
         * @param {string} userId 
         * @param {UpdateUserLandingPagePreferenceRequestDto} updateUserLandingPagePreferenceRequestDto Landing page preference to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLandingPagePreference(userId: string, updateUserLandingPagePreferenceRequestDto: UpdateUserLandingPagePreferenceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserLandingPagePreference(userId, updateUserLandingPagePreferenceRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserLandingPagePreferenceRestApi - interface
 */
export interface UserLandingPagePreferenceRestApiInterface {
    /**
     * Returns the user\'s preferred landing page. Returns MY_PROFILE if not set.
     * @summary Get user\'s landing page preference
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserLandingPagePreference(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserLandingPagePreferenceResponseDto>;

    /**
     * Sets the user\'s preferred landing page for the application
     * @summary Update user\'s landing page preference
     * @param {string} userId 
     * @param {UpdateUserLandingPagePreferenceRequestDto} updateUserLandingPagePreferenceRequestDto Landing page preference to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserLandingPagePreference(userId: string, updateUserLandingPagePreferenceRequestDto: UpdateUserLandingPagePreferenceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * UserLandingPagePreferenceRestApi - object-oriented interface
 */
export class UserLandingPagePreferenceRestApi extends BaseAPI implements UserLandingPagePreferenceRestApiInterface {
    /**
     * Returns the user\'s preferred landing page. Returns MY_PROFILE if not set.
     * @summary Get user\'s landing page preference
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserLandingPagePreference(userId: string, options?: RawAxiosRequestConfig) {
        return UserLandingPagePreferenceRestApiFp(this.configuration).getUserLandingPagePreference(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the user\'s preferred landing page for the application
     * @summary Update user\'s landing page preference
     * @param {string} userId 
     * @param {UpdateUserLandingPagePreferenceRequestDto} updateUserLandingPagePreferenceRequestDto Landing page preference to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserLandingPagePreference(userId: string, updateUserLandingPagePreferenceRequestDto: UpdateUserLandingPagePreferenceRequestDto, options?: RawAxiosRequestConfig) {
        return UserLandingPagePreferenceRestApiFp(this.configuration).updateUserLandingPagePreference(userId, updateUserLandingPagePreferenceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

